import { action, computed } from "mobx";
import { ConsultantEditorStore } from "../ConsultantEditorStore";

export interface ExpertiseProfession {
  professionName: string;
}

export abstract class ExpertiseProfessionStore<
  TProfession extends ExpertiseProfession = ExpertiseProfession
> {
  protected constructor(
    public profession: string,
    public storeIndex: number,
    public editorStore: ConsultantEditorStore
  ) {}

  abstract initForm();

  @computed get currentExpertiseProfession(): TProfession | undefined {
    // The form holds the UI shape of the profession the subclass declares,
    // which is richer than the generated GraphQL input union.
    const profession: ExpertiseProfession | undefined =
      this.editorStore.form.values.professions[this.storeIndex];

    return profession as TProfession | undefined;
  }

  @computed get selectedSystems(): string[] {
    return this.editorStore.form.values.professions[this.storeIndex]?.systems || [];
  }

  get systems(): string[] {
    return this.editorStore.getSystemsOnProfession(this.profession);
  }

  @action addSystems = (items: string[]) => {
    this.editorStore.form.setValue(`professions.${this.storeIndex}.systems`, items);
  };

  @action deleteExpertise = () => {
    this.editorStore.removeExpertiseProfession(this.profession);
  };

  @action setStoreIndex = (index: number) => {
    this.storeIndex = index;
  };

  @action addSpec<T>(spec: T) {
    this.editorStore.form.push(`professions.${this.storeIndex}.specializations`, spec);
  }

  initialSetup() {
    const res: string[] | undefined =
      this.editorStore.form.values.professions[this.storeIndex].systems;

    if (!res) {
      this.editorStore.form.setValue(`professions.${this.storeIndex}.systems`, []);
    }
  }
}
